import styled from "styled-components";

export const AoiSaveContainer = styled.div`
    .ant-card-head {
        color: white;

        svg {
            fill: white;
        }
    }

    .ant-form-item-label {
        text-align: start;
    }

    .ant-form-item-label label {
        color: white;
        font-size: 13px;
    }

    .ant-card-body {
        padding: 10px;
    }

    .ant-form-item {
        margin-bottom: 0 !important;
    }

    .ant-form-item-control-input-content {
        display: contents;
    }

    .ant-btn {
        padding: 4px 5px;
    }
`;
